export default "__VITE_ASSET__BJPYAGDt__"